const pseudoComponents_VenezHeavy = [
  { name: "PC01", Tb: 200.0, MW: 175.0, Tc: 314.60, Pc: 45.00, omega: 0.100, SG: 0.600 },
  {
    name: "PC02",
    Tb: 205.0,
    MW: 179.0,
    Tc: 321.60,
    Pc: 44.21,
    omega: 0.105,
    SG: 0.603,
  },
  {
    name: "PC03",
    Tb: 210.0,
    MW: 183.0,
    Tc: 328.70,
    Pc: 43.41,
    omega: 0.110,
    SG: 0.608,
  },
  {
    name: "PC04",
    Tb: 215.0,
    MW: 187.0,
    Tc: 335.70,
    Pc: 42.62,
    omega: 0.115,
    SG: 0.608,
  },
  {
    name: "PC05",
    Tb: 220.0,
    MW: 191.0,
    Tc: 342.60,
    Pc: 41.83,
    omega: 0.120,
    SG: 0.615,
  },
  {
    name: "PC06",
    Tb: 225.0,
    MW: 195.0,
    Tc: 349.60,
    Pc: 41.03,
    omega: 0.125,
    SG: 0.615,
  },
  {
    name: "PC07",
    Tb: 236.7,
    MW: 204.3,
    Tc: 365.60,
    Pc: 40.24,
    omega: 0.137,
    SG: 0.618,
  },
  {
    name: "PC08",
    Tb: 250.0,
    MW: 215.0,
    Tc: 383.70,
    Pc: 39.45,
    omega: 0.150,
    SG: 0.625,
  },
  {
    name: "PC09",
    Tb: 263.3,
    MW: 225.7,
    Tc: 401.60,
    Pc: 38.66,
    omega: 0.163,
    SG: 0.632,
  },
  {
    name: "PC10",
    Tb: 276.7,
    MW: 236.3,
    Tc: 419.30,
    Pc: 37.86,
    omega: 0.177,
    SG: 0.638,
  },
  {
    name: "PC11",
    Tb: 290.0,
    MW: 247.0,
    Tc: 436.70,
    Pc: 37.07,
    omega: 0.190,
    SG: 0.645,
  },
  {
    name: "PC12",
    Tb: 303.3,
    MW: 257.7,
    Tc: 453.90,
    Pc: 36.28,
    omega: 0.203,
    SG: 0.652,
  },
  {
    name: "PC13",
    Tb: 318.3,
    MW: 269.7,
    Tc: 473.00,
    Pc: 35.48,
    omega: 0.218,
    SG: 0.659,
  },
  {
    name: "PC14",
    Tb: 335.0,
    MW: 283.0,
    Tc: 493.90,
    Pc: 34.69,
    omega: 0.235,
    SG: 0.667,
  },
  {
    name: "PC15",
    Tb: 351.7,
    MW: 296.3,
    Tc: 514.50,
    Pc: 33.90,
    omega: 0.252,
    SG: 0.676,
  },
  {
    name: "PC16",
    Tb: 368.3,
    MW: 309.7,
    Tc: 534.80,
    Pc: 33.10,
    omega: 0.268,
    SG: 0.684,
  },
  {
    name: "PC17",
    Tb: 385.0,
    MW: 323.0,
    Tc: 554.80,
    Pc: 32.31,
    omega: 0.285,
    SG: 0.693,
  },
  {
    name: "PC18",
    Tb: 401.7,
    MW: 336.3,
    Tc: 574.50,
    Pc: 31.52,
    omega: 0.302,
    SG: 0.701,
  },
  {
    name: "PC19",
    Tb: 418.3,
    MW: 349.7,
    Tc: 593.90,
    Pc: 30.72,
    omega: 0.318,
    SG: 0.709,
  },
  {
    name: "PC20",
    Tb: 435.0,
    MW: 363.0,
    Tc: 613.00,
    Pc: 29.93,
    omega: 0.335,
    SG: 0.718,
  },
  {
    name: "PC21",
    Tb: 451.7,
    MW: 376.3,
    Tc: 631.80,
    Pc: 29.14,
    omega: 0.352,
    SG: 0.726,
  },
  {
    name: "PC22",
    Tb: 466.7,
    MW: 388.3,
    Tc: 648.50,
    Pc: 28.34,
    omega: 0.367,
    SG: 0.733,
  },
  {
    name: "PC23",
    Tb: 480.0,
    MW: 399.0,
    Tc: 663.20,
    Pc: 27.55,
    omega: 0.380,
    SG: 0.740,
  },
  {
    name: "PC24",
    Tb: 493.3,
    MW: 409.7,
    Tc: 677.70,
    Pc: 26.76,
    omega: 0.393,
    SG: 0.747,
  },
  {
    name: "PC25",
    Tb: 506.7,
    MW: 420.3,
    Tc: 692.00,
    Pc: 25.97,
    omega: 0.407,
    SG: 0.753,
  },
  {
    name: "PC26",
    Tb: 520.0,
    MW: 431.0,
    Tc: 706.20,
    Pc: 25.17,
    omega: 0.420,
    SG: 0.760,
  },
  {
    name: "PC27",
    Tb: 533.3,
    MW: 441.7,
    Tc: 720.20,
    Pc: 24.38,
    omega: 0.433,
    SG: 0.767,
  },
  {
    name: "PC28",
    Tb: 546.7,
    MW: 452.3,
    Tc: 734.00,
    Pc: 23.59,
    omega: 0.447,
    SG: 0.773,
  },
  {
    name: "PC29",
    Tb: 560.0,
    MW: 463.0,
    Tc: 747.70,
    Pc: 22.79,
    omega: 0.460,
    SG: 0.780,
  },
  {
    name: "PC30",
    Tb: 573.3,
    MW: 473.7,
    Tc: 761.20,
    Pc: 22.00,
    omega: 0.473,
    SG: 0.787,
  },
];

export default pseudoComponents_VenezHeavy;
